import Modal from "../../../controls/Modal";
import { ComponentEx, connect, translate } from "../../../controls/ComponentEx";
import { showCategoriesDialog } from "../actions/session";
import CategoryList from "./CategoryList";
import * as React from "react";
class CategoryDialog extends ComponentEx {
    render() {
        const { t, showDialog } = this.props;
        return (React.createElement(Modal, { show: showDialog, onHide: this.hide },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t("Categories"))),
            React.createElement(Modal.Body, null,
                React.createElement(CategoryList, null))));
    }
    hide = () => {
        this.props.onShowSelf(false);
    };
}
function mapStateToProps(state) {
    return {
        showDialog: state.session.categories.showDialog,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onShowSelf: (show) => dispatch(showCategoriesDialog(show)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(CategoryDialog));
